import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            // Wait for the target element to mount, then scroll to it
            setTimeout(() => {
                const el = document.getElementById(hash.replace("#", ""));
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                    return;
                }
                window.scrollTo({ top: 0, behavior: "instant" });
            }, 80);
        } else {
            window.scrollTo({ top: 0, behavior: "instant" });
        }
    }, [pathname, hash]);
    return null;
}
